import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { AgGridColumn } from '@ag-grid-community/react';
import DataGrid from '../../common/components/DataGrid';

class TimeOffReportGrid extends React.Component {
  render() {
    const { rowData = [], endDate, onExportReady, collapsed, deliverables = [] } = this.props;
    const baseColumns = [
      <AgGridColumn field="endDate" headerName="Week Ending" width={125} key="endDate" />,
      <AgGridColumn field="status" width={175} key="status" />,
      <AgGridColumn field="name" key="name" />,
      <AgGridColumn field="email" key="email" />,
    ];

    const detailColumns = [
      <AgGridColumn field="milestone" key="milestone" />,
      <AgGridColumn field="deliverable" key="deliverable" />,
      <AgGridColumn field="taskdate" width={110} key="taskdate" />,
      <AgGridColumn field="hours" width={110} key="hours" />,
      <AgGridColumn field="comment" key="comment" />,
    ];

    const deliverableColumns = deliverables.flatMap(deliverable => [
      <AgGridColumn
        key={deliverable.field}
        field={deliverable.field}
        headerName={deliverable.name}
      />,
      <AgGridColumn
        key={deliverable.totalField}
        field={deliverable.totalField}
        headerName={`Total ${deliverable.name}`}
        width={120}
      />,
    ]);

    const columns = collapsed
      ? [...baseColumns, ...deliverableColumns]
      : [...baseColumns, ...detailColumns];

    return (
      <DataGrid
        rowData={rowData}
        onExportReady={onExportReady}
        key={`${collapsed ? 'collapsed' : 'expanded'}-${deliverables.length}`}
        exportFileName={`TimeOffReport-WeekEnding(${endDate})-ExportedOn(${moment(new Date()).format('YYYYMMDD-hhmm')}).csv`}
      >
        {columns}
      </DataGrid>
    );
  }
}

export default withRouter(TimeOffReportGrid);
